module.exports = __webpack_public_path__ + "static/blog-01-70e608d855bbd41ab66b4ff95f124bf2.jpg";